import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";
import Page01 from "./pdfPages/Page01";
import { SingleSection } from "./MoodboardView";
import axios, { all } from "axios";
import Logo192 from "../../../assets/logo-full.png";
import AbLogo from "../../../assets/logo192.png";
import watermark from "../../../assets/water.png";
import { set } from "react-hook-form";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import pageFlipSound from "../../../assets/pageFlip.mp3";

// import intro from "../../../../assets/MDP.webp";
import materialIntro from "../../../assets/materialIntro02.jpg";
import {
  getAxiosConfig,
  getFlipbookHeight,
  getMinioImage,
} from "../../../utils/helpers";
import Img from "../../../components/Img";
import { Button, position } from "@chakra-ui/react";
import PopupWrapper from "../../../components/PopupWrapper";
import abWatermark from "../../../assets/abWatermark.png"; // Import the watermark image
import { toast } from "react-toastify";
import CarasouelImages from "../../../components/CarasouelImages";
import OutroImage from "../../../components/OutroImage";
import flipbookImages from "../../../assets/flipbook";
import ImgOptimized from "../../../components/ImgOptimized";
import classNames from "classnames";
import BG from "../../../assets/3dBg.png";
import QuantityTable from "./QuantityTable";
import { Icon } from "@iconify/react/dist/iconify.js";
import TableHeadingPage from "./TableHeadingPage";

const PublicView = ({ isEdit = false }) => {
  // const {
  //   state,
  // } = useLocation();
  // const data = state?.data || {};
  const { id, projectName } = useParams();
  isEdit = false;

  const [materialData, setMaterialData] = useState({});
  const [projectdata, setProjectData] = useState({});
  const printRef = useRef();
  const ref = React.useRef();
  const flipBookRef = React.useRef();
  const [containerWidth, setContainerWidth] = useState(1200);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState({
    heading: "",
    material: "",
    image: "",
  });
  const positionRef = useRef();
  const { state } = useLocation();
  console.log({ state });
  const nav = useNavigate();
  const [relatedMaterials, setRelatedMaterials] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(2);
  const [saveFinalMaterial, setSaveFinalMaterial] = useState([]);
  const [isAddMaterialPopupOpen, setIsAddMaterialPopupOpen] = useState([
    false,
    null,
  ]); // [isOpen,zone]
  const [addSelectedMaterial, setAddSelectedMaterial] = useState(null);
  const [metaDescriptions, setMetaDescriptions] = useState({});
  // const [zoneMaterials, setZoneMaterials] = useState([]);
  const [viewBy, setViewBy] = useState("render"); // "zone" or "brand"
  const [isViewByLoading, setIsViewByLoading] = useState(false);
  const [flipBookPosition, setFlipBookPosition] = useState({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
  });
  const [skipButtonPosition, setSkipButtonPosition] = useState({
    top: -100,
    right: 20,
  });
  console.log("RElated MATERIALS", relatedMaterials, selectedMaterial);
  // Page flip sound
  const audioRef = useRef();
  useEffect(() => {
    audioRef.current = new window.Audio(pageFlipSound);
  }, []);

  const handlePageFlip = (e) => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }
    // Update current page index
    if (e && typeof e.data === "object" && typeof e.data.page === "number") {
      setCurrentPage(e.data.page);
    }
  };

  const handleViewByChange = (newView) => {
    setIsViewByLoading(true);
    setViewBy(newView);
    setTimeout(() => {
      setIsViewByLoading(false);
    }, 2000);
  };

  const handleDownload = async () => {
    setLoading(true);
    const elementNodeList = document.getElementsByClassName("pdfSection");
    const elements = Array.from(elementNodeList);
    if (elements.length === 0) {
      console.error("No elements found");
      setLoading(false);
      return;
    }

    const pdfWidth = 1200;
    const pdfHeight = 1200 / 1.77;

    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: [pdfWidth, pdfHeight],
    });

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      // Force the element to be rendered exactly as per PDF size
      element.style.display = "block";
      element.style.position = "relative";
      element.style.left = "0px";
      element.style.width = `${pdfWidth}px`;
      element.style.height = `${pdfHeight}px`;

      const canvas = await html2canvas(element, {
        scale: 1, // No extra scaling
        width: pdfWidth,
        height: pdfHeight,
      });

      const imgData = canvas.toDataURL("image/png");

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      const watermarkWidth = 800; // Adjust watermark size as needed
      const watermarkHeight = 400;
      const watermarkX = (pdfWidth - watermarkWidth) / 2; // Center horizontally
      const watermarkY = (pdfHeight - watermarkHeight) / 2; // Center vertically

      // pdf.addImage(
      //   abWatermark,
      //   "PNG",
      //   watermarkX,
      //   watermarkY,
      //   watermarkWidth,
      //   watermarkHeight
      // );
    }

    pdf.save("my-document.pdf");
    setLoading(false);
  };

  // console.log("projectdata", projectdata);
  // data is an array of page objects. Each object has:
  //   type: "renderImage" | "section" | "table"
  //   + relevant fields for each type
  const data = [];
  const MAX_IMG_PER_PAGE = 7;

  // Helper: collect flat image entries from materials in a zone
  const collectImageEntries = (items, zone) =>
    items.flatMap((item) =>
      (item?.images?.filter((_, i) => i <= 1) || []).map((img) => ({
        image: img,
        productCode: item.productCode,
        brand: item?.brand || "",
        heading: zone,
        material: item,
        linkedImage: item?.linkedImage || "unknown",
      })),
    );

  // Helper: build table rows from materials in a zone
  const buildTableRows = (items, zone) =>
    items.map((item) => {
      const row = {
        sku: item.productCode || "",
        quantity: item.projects?.[0]?.quantity || "",
        uom: item.projects?.[0]?.uom || "",
        brand: item?.brand || "",
        heading: zone,
        material: item,
      };
      if (item.otherDetails?.size) row.size = item.otherDetails.size;
      return row;
    });

  // Helper: push paginated section pages from collected entries
  const pushSectionPages = (collected, heading, zone) => {
    for (let i = 0; i < collected.length; i += MAX_IMG_PER_PAGE) {
      const chunk = collected.slice(i, i + MAX_IMG_PER_PAGE);
      data.push({
        type: "section",
        heading,
        zone: zone ?? chunk.map((c) => c.heading),
        images: chunk.map((c) => c.image),
        skus: chunk.map((c) => c.productCode),
        brands: chunk.map((c) => c.brand),
        materials: chunk.map((c) => c.material),
      });
    }
  };

  if (viewBy === "brand") {
    // Group all items by brand first
    const brandGroups = {};
    const brandTableRows = {};

    Object.entries(materialData).forEach(([zone, items]) => {
      items.forEach((item) => {
        const brand = item?.brand || "Unknown";
        if (!brandGroups[brand]) {
          brandGroups[brand] = [];
          brandTableRows[brand] = [];
        }
        brandTableRows[brand].push(...buildTableRows([item], zone));
        collectImageEntries([item], zone).forEach((entry) =>
          brandGroups[brand].push(entry),
        );
      });
    });

    Object.entries(brandGroups).forEach(([brand, items]) => {
      // Sub-group by linkedImage (render image)
      const byRender = {};
      items.forEach((item) => {
        const key = item.linkedImage;
        if (!byRender[key]) byRender[key] = [];
        byRender[key].push(item);
      });

      Object.entries(byRender).forEach(([linkedImg, renderItems]) => {
        data.push({ type: "renderImage", linkedImage: linkedImg });
        pushSectionPages(renderItems, brand);
      });

      // Table page after all section pages for this brand
      data.push({
        type: "table",
        heading: brand,
        tableData: brandTableRows[brand],
      });
    });
  } else if (viewBy === "render") {
    // Group materials by linkedImage, then by zone
    const renderGroups = {};
    Object.entries(materialData).forEach(([zone, items]) => {
      items.forEach((item) => {
        const linkedImg = item?.linkedImage || "unknown";
        if (!renderGroups[linkedImg]) renderGroups[linkedImg] = {};
        if (!renderGroups[linkedImg][zone]) renderGroups[linkedImg][zone] = [];
        renderGroups[linkedImg][zone].push(item);
      });
    });

    Object.entries(renderGroups).forEach(([linkedImg, zones]) => {
      data.push({ type: "renderImage", linkedImage: linkedImg });

      Object.entries(zones).forEach(([zone, items]) => {
        const collected = collectImageEntries(items, zone);
        pushSectionPages(collected, zone, zone);

        data.push({
          type: "table",
          heading: zone,
          tableData: buildTableRows(items, zone),
        });
      });
    });
  }
  console.log({ data, materialData, state });
  // console.log({ data });
  async function fetchMeta() {
    try {
      const {
        data: {
          data: { metaData },
        },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/material/project-meta/${id}`,
      );
      setMetaDescriptions(metaData);
    } catch (error) {}
  }
  async function fetchProjectMaterials() {
    try {
      // const {
      //   data: { data },
      // } = await axios.get(
      //   `${process.env.REACT_APP_BACK_URL}/api/material/get-project/${id}`,
      // );
      const response = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/images/${id}`,
      );
      // console.log("Project Materials", data);
      // setMaterialData(project?.[0]?.materialData)
      let obj = {};

      (response.data?.projectImageMaterials || []).forEach((m) => {
        (m.materials || []).forEach((mat) => {
          if (obj[mat.zone]) {
            obj[mat.zone].push({
              ...mat?.materialId,
              linkedImage: m?.image,
              projects: [{ quantity: mat?.quantity, uom: mat?.uom }],
            });
          } else {
            obj[mat.zone] = [
              {
                ...mat?.materialId,
                linkedImage: m?.image,
                projects: [{ quantity: mat?.quantity, uom: mat?.uom }],
              },
            ];
          }
        });
      });
      console.log({ obj });
      // data?.materials?.forEach((item) => {
      //   item?.projects?.[0]?.zones?.forEach((zone) => {
      //     if (!obj[zone]) {
      //       obj[zone] = [item];
      //     } else {
      //       obj[zone].push(item);
      //     }
      //   });
      // });
      return obj;
      // setProjectData(data?.project);
    } catch (error) {
      console.log("ERROR in material", error?.message);
      return {};
    } finally {
      fetchMeta();
    }
  }
  async function fetchRelatedMaterials(zone, materialType) {
    if (!zone) return;
    try {
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/material/get-all`,
        getAxiosConfig({
          zone,
          ...(materialType && { materialType: materialType }),
        }),
      );
      // console.log("Related Materials", data);
      setRelatedMaterials(data?.collections);
    } catch (error) {
      console.log("ERROR in fetching related materials", error?.message);
    }
  }

  function handleSwapMAterial(newMaterial) {
    let key = selectedMaterial?.heading;
    // console.log({selectedMaterial, newMaterial});
    setSaveFinalMaterial((p) => [
      ...p,
      {
        zone: selectedMaterial?.heading,
        from: selectedMaterial?.material?._id,
        to: newMaterial?._id,
      },
    ]);
    // return;
    setMaterialData((prev) => {
      let update = prev[key];
      let updatedMaterials = update.map((v) => {
        if (v?._id == selectedMaterial?.material?._id) {
          setSelectedMaterial((prev) => ({
            ...prev,
            material: newMaterial,
            image:
              newMaterial?.images?.[
                prev.material.images?.indexOf(prev.image) <
                  newMaterial?.images?.length &&
                prev.material.images?.indexOf(prev.image) >= 0
                  ? prev.material.images?.indexOf(prev.image)
                  : 0
              ] || "",
          }));
          return newMaterial;
        } else return v;
      });
      return { ...prev, [key]: updatedMaterials };
    });
  }

  async function handleSaveFinalMaterials() {
    try {
      setIsSaving(true);
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACK_URL}/api/material/project-material/${id}`,
        {
          materialData: saveFinalMaterial,
        },
        getAxiosConfig(),
      );
      setSaveFinalMaterial([]);
      toast.success("Materials saved successfully");
    } catch (error) {
      console.log("ERROR in saving final materials", error?.message);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Error in saving materials",
      );
    } finally {
      setIsSaving(false);
    }
  }
  function mergeMatertialData(mData, exstingMdata) {
    const result = JSON.parse(JSON.stringify(exstingMdata)); // deep clone

    for (const zone in mData) {
      if (!result[zone]) {
        // Zone doesn't exist in existing data, add it entirely
        result[zone] = mData[zone];
      } else {
        // Zone exists — group mData products by materialType
        const mDataByType = {};
        for (const product of mData[zone]) {
          const type = product.materialType;
          if (!mDataByType[type]) mDataByType[type] = [];
          mDataByType[type].push(product);
        }

        // Replace matching materialType products, keep non-matching ones
        const replacedTypes = new Set();
        const filteredExisting = result[zone].filter((product) => {
          const type = product.materialType;
          if (mDataByType[type]) {
            replacedTypes.add(type);
            return false; // remove old product of same type
          }
          return true; // keep product of different type
        });

        // Add mData products for replaced (and new) types
        const newProducts = Object.values(mDataByType).flat();
        result[zone] = [...filteredExisting, ...newProducts];
      }
    }

    return result;
  }

  async function settingMaterialDataForExistingMaterials() {
    const exstingMdata = await fetchProjectMaterials();
    if (state?.designData?.selectedMaterial) {
      let imgLink = state?.selectedProjectImage;
      let mData = {};
      Object.entries(state?.designData?.selectedMaterial || {}).forEach(
        ([key, value]) => {
          mData[key] = (value || []).map((v) => ({
            ...(v?.material || {}),
            projects: [{ quantity: v?.quantity || "", uom: v?.uom || "" }],
            linkedImage: imgLink,
          }));
        },
      );
      let finalData = mergeMatertialData(mData, exstingMdata);
      // console.log({mData, exstingMdata, finalData});
      setMaterialData(finalData);
    } else {
      setMaterialData(exstingMdata);
    }
  }

  useEffect(() => {
    // if(projectdata?._id){

    // fetchMetaData();
    // }
    settingMaterialDataForExistingMaterials();
  }, [
    JSON.stringify({
      m: state?.designData?.selectedMaterial,
      sImg: state?.selectedProjectImage,
    }),
  ]);

  useEffect(() => {
    const updateWidth = () => {
      if (ref?.current) {
        setContainerWidth(ref.current.clientWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    setTotalPages(
      Math.ceil(
        (data.length + flipbookImages.length + 1) /
          (containerWidth <= 1022 ? 1 : 1),
      ) + 1,
    ); // +1 for cover page,+1for  outer inside, // +5 for flipbook images
    setCurrentPage(0);
  }, [materialData, JSON.stringify(data), viewBy]);

  useEffect(() => {
    const updatePosition = () => {
      if (!flipBookRef.current?.pageFlip) return;
      const rect = flipBookRef.current.pageFlip()?.getBoundsRect();
      if (rect) {
        setFlipBookPosition({
          top: rect.top,
          left: rect.left,
          right: rect.right,
          bottom: rect.bottom,
          width: rect.width,
          height: rect.height,
        });
      }
    };

    setTimeout(() => {
      updatePosition();
    }, 100);
    window.addEventListener("resize", updatePosition);
    const resizeObserver = new ResizeObserver(updatePosition);
    if (ref?.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      window.removeEventListener("resize", updatePosition);
      resizeObserver.disconnect();
    };
  }, [containerWidth]);

  useEffect(() => {
    const updateSkipButtonPosition = () => {
      if (flipBookPosition?.top == 0 && flipBookPosition?.height == 0) return;
      setSkipButtonPosition({
        top:
          (flipBookPosition?.top || 0) + (flipBookPosition?.height || 0) + 20,
        right: 20,
      });
    };

    updateSkipButtonPosition();
  }, [flipBookPosition]);

  const goToNextPage = () => {
    if (currentPage < totalPages - 1) {
      handlePageFlip();
      flipBookRef.current?.pageFlip()?.flipNext("top");
      setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 0) {
      handlePageFlip();
      flipBookRef.current?.pageFlip()?.flipPrev("top");
      setCurrentPage((prev) => Math.max(prev - 1, 0));
    }
  };
  let modifiedWidth =
    containerWidth > 1062
      ? Math.min(containerWidth - 60, window.innerHeight * 0.85 * 1.6) //1.6-> 1.77
      : containerWidth - containerWidth / 20;
  // if (testView) {
  //   modifiedWidth += 120;
  // }
  const flipbookHeight = getFlipbookHeight(modifiedWidth);
  const minFlipbookWidth =
    // containerWidth/2 -16
    containerWidth < 480
      ? 520
      : containerWidth < 640
        ? 320
        : (modifiedWidth + 4.87) / 2.11;

  // console.log("Public View Data", data, materialData, saveFinalMaterial, totalPages, currentPage);
  // console.log("----SELECT MATERIAL", selectedMaterial)
  const getPosition = () => {
    if (!flipBookRef.current?.pageFlip) return;
    console.log(
      flipBookRef.current,
      flipBookRef.current.pageFlip(),
      "FLIPBOOK",
    );
    const rect = flipBookRef.current.pageFlip()?.getBoundsRect();
    if (!rect) return {};
    return {
      top: rect.top, // relative to viewport
      left: rect.left,
      right: rect.right,
      bottom: rect.bottom,
      width: rect.width,
      height: rect.height,
    };
  };

  let flipBookPostiton = getPosition();
  const handleSkipPage = () => {
    const skipToPage = 1 + 5; // 1 intro + 5 flipbook images = page 6
    if (flipBookRef?.current && currentPage < skipToPage) {
      flipBookRef?.current?.pageFlip()?.flip(skipToPage);
      setCurrentPage(skipToPage);
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play();
      }
    }
  };

  console.log({
    data,
    state,
    materialData,
    currentPage,
    totalPages,
    position: getPosition(),
  });
  const downloadPdf = async () => {
    const element = document.getElementById("landscapPdf");

    if (!element) {
      console.error("Element #landscapPdf not found");
      return;
    }

    try {
      setLoading(true);
      const startTime = performance.now();

      // Clone element
      const clonedElement = element.cloneNode(true);

      // OPTIMIZE: Remove unnecessary attributes and data
      cleanElement(clonedElement);

      const html = clonedElement.innerHTML;
      const styles = getInlineStyles();
      const baseUrl = window.location.origin;

      // Check payload size
      const payloadSize = new Blob([html]).size;
      console.log(`HTML payload size: ${(payloadSize / 1024).toFixed(2)} KB`);

      if (payloadSize > 100 * 1024 * 1024) {
        // 100MB
        alert("Content too large. Please reduce the size of your layout.");
        return;
      }

      console.log(
        `Preparation took: ${(performance.now() - startTime).toFixed(0)}ms`,
      );
      console.log({
        html: html,
        styles: styles,
        baseUrl: baseUrl,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BACK_URL}/api/pdf`,
        {
          // const response = await fetch(`http://localhost:5050/pdf`, {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            html: html,
            styles: styles,
            baseUrl: baseUrl,
          }),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to generate PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `layout-${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      console.log(
        `Total time: ${(performance.now() - startTime).toFixed(0)}ms`,
      );
    } catch (err) {
      console.error("PDF download error:", err);

      if (
        err.message.includes("entity too large") ||
        err.message.includes("PayloadTooLargeError")
      ) {
        alert(
          "The content is too large to generate PDF. Please reduce the size.",
        );
      } else {
        alert("Failed to generate PDF. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Clean element to reduce payload size
  function cleanElement(element) {
    // Remove React-specific attributes
    const allElements = element.querySelectorAll("*");
    allElements.forEach((el) => {
      // Remove data attributes added by React/frameworks
      Array.from(el.attributes).forEach((attr) => {
        if (
          attr.name.startsWith("data-react") ||
          attr.name.startsWith("data-testid") ||
          attr.name.startsWith("data-")
        ) {
          el.removeAttribute(attr.name);
        }
      });

      // Remove event listeners (they're useless in PDF)
      el.removeAttribute("onclick");
      el.removeAttribute("onload");
      el.removeAttribute("onerror");
    });

    // Remove script tags (not needed in PDF)
    const scripts = element.querySelectorAll("script");
    scripts.forEach((script) => script.remove());

    // Remove comments
    removeComments(element);

    // Convert inline base64 images to external URLs if possible
    convertBase64ToUrls(element);
  }

  // Remove HTML comments
  function removeComments(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_COMMENT,
      null,
      false,
    );

    const comments = [];
    while (walker.nextNode()) {
      comments.push(walker.currentNode);
    }

    comments.forEach((comment) => comment.remove());
  }

  // Convert base64 images back to URLs if they were originally URLs
  function convertBase64ToUrls(element) {
    const images = element.querySelectorAll('img[src^="data:"]');
    images.forEach((img) => {
      // If image has data-original-src, restore it
      const originalSrc = img.getAttribute("data-original-src");
      if (originalSrc) {
        img.src = originalSrc;
        img.removeAttribute("data-original-src");
      }
    });
  }

  // Get inline styles
  function getInlineStyles() {
    const inlineStyles = document.querySelectorAll("style");
    let styles = "";

    inlineStyles.forEach((style) => {
      styles += style.textContent + "\n";
    });

    return styles;
  }

  if (isViewByLoading) {
    return (
      <div className="fixed inset-0 z-50 bg-black backdrop-blur-sm flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 border-4 border-teal-200 border-t-teal-500 rounded-full animate-spin"></div>
          <p className="text-white text-lg font-semibold">
            Reorganizing materials...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundImage: `url(${BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundBlendMode: "darken",
      }}
      ref={ref}
      className={classNames(
        "mx-auto relative w-full ",
        isEdit ? "overflow-y-auto max-h-auto" : "overflow-y-hidden h-screen",
      )}
    >
      {/* Left Control */}
      <button
        onClick={goToPrevPage}
        disabled={currentPage === 0}
        className={`absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-gray-300 bg-opacity-50 hover:bg-opacity-70 text-white p-2 rounded-full transition-all ${
          currentPage === 0 ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      {/* Right Control */}
      <button
        onClick={goToNextPage}
        disabled={currentPage === totalPages - 1}
        className={`absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-gray-300 bg-opacity-50 hover:bg-opacity-70 text-white p-2 rounded-full transition-all ${
          currentPage === totalPages - 1 ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>

      {/* Download Button */}
      <div className="absolute top-4 right-4 z-10 space-x-4 w-fit">
        {isEdit && (
          <Button
            onClick={handleSaveFinalMaterials}
            colorScheme="teal"
            variant="outline"
            // disabled={loading}
            isLoading={isSaving}
            loadingText="Saving..."
          >
            Save
          </Button>
        )}
        <Button
          // onClick={handleDownload}
          onClick={downloadPdf}
          colorScheme="teal"
          variant="solid"
          // disabled={loading}
          isLoading={loading}
          loadingText="Downloading..."
        >
          Download PDF
        </Button>
      </div>
      <div className="flex justify-center items-center w-fit gap-0 my-4 absolute top-4 left-1/2 -translate-x-1/2 z-10">
        <button
          onClick={() => handleViewByChange("render")}
          disabled={isViewByLoading}
          className={classNames(
            "px-6 py-2 rounded-l-lg font-semibold transition-all",
            viewBy === "render"
              ? "bg-teal-500 text-white shadow-lg"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300",
            isViewByLoading && "opacity-50 cursor-not-allowed",
          )}
        >
          Render
        </button>
        <button
          onClick={() => handleViewByChange("brand")}
          disabled={isViewByLoading}
          className={classNames(
            "px-6 py-2 rounded-r-lg font-semibold transition-all",
            viewBy === "brand"
              ? "bg-teal-500 text-white shadow-lg"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300",
            isViewByLoading && "opacity-50 cursor-not-allowed",
          )}
        >
          By Brand
        </button>
      </div>

      <div className="flex flex-col gap-6 items-center justify-center w-[95%] h-fit mx-auto relative overflow-hidden ">
        <Link to="/home" className="absolute top-6 left-10">
          <ImgOptimized
            src={Logo192}
            className=" w-[130px]"
            alt="AirBrick Logo"
          />
        </Link>
        <div
          onClick={() =>
            nav(state?.returnUrl ? state?.returnUrl : -1, { state: state })
          }
          className="absolute top-8 left-0 bg-black/30 p-0.5 rounded-md cursor-pointer hover:bg-black/50 z-[100]"
        >
          <Icon icon="mdi:arrow-left" width="24" height="24" color="white" />
        </div>
        {/* <div className="w-full h-full grow"> */}
        {data.length > 0 && !isViewByLoading && (
          <div className="w-full h-screen    flex flex-col items-center justify-center relative  rotate-90 sm:rotate-0 sm:overflow-hidden ">
            <HTMLFlipBook
              key={totalPages}
              ref={flipBookRef}
              className="w-fit h-fit  "
              // width={containerWidth}
              // height={
              //   relatedMaterials?.length > 0 && selectedMaterial?.material
              //     ? 800
              //     : 1200
              // }
              width={containerWidth < 480 ? 520 : modifiedWidth}
              height={flipbookHeight}
              minWidth={minFlipbookWidth}
              // minWidth={800}
              // minHeight={800}
              autoSize={true}
              size="fixed"
              usePortrait={true}
              useMouseEvents={false}
              // showCover={true}
              drawShadow={true}
              flippingTime={600}
              renderOnlyPageLengthChange={true}

              // onFlip={handlePageFlip}
            >
              <Page key={"intro"} number={1} handleSkipPage={handleSkipPage}>
                <div className="p-2 rounded-xl overflow-hidden h-full">
                  <Page01
                    ref={printRef}
                    projectName={projectName}
                    isMaterial={true}
                  />{" "}
                </div>
              </Page>
              {flipbookImages
                .filter((_, i) => i <= 4)
                .map((image, idx) => (
                  <Page
                    key={"intro"}
                    number={idx + 2}
                    handleSkipPage={handleSkipPage}
                  >
                    <div className="p-2 rounded-xl overflow-hidden h-full">
                      <ImgOptimized
                        width="100%"
                        height="100%"
                        src={image}
                        alt={`Flipbook Image ${idx + 1}`}
                        className="w-full h-full "
                      />
                    </div>
                  </Page>
                ))}

              {data.length > 0 &&
                !isViewByLoading &&
                (() => {
                  let lastRenderImage = null;
                  const sectionPages = [];
                  const tablePages = [];

                  data.forEach((page, idx) => {
                    if (page.type === "renderImage") {
                      lastRenderImage = page.linkedImage;
                      return;
                    }

                    if (page.type === "table") {
                      tablePages.push(
                        <Page
                          key={`table-${idx}`}
                          number={1 + 5 + idx + 1}
                          handleSkipPage={handleSkipPage}
                        >
                          <QuantityTable
                            isViewByZone={true}
                            values={page.tableData}
                            heading={page.heading}
                          />
                        </Page>,
                      );
                      return;
                    }

                    if (page.type === "section") {
                      sectionPages.push(
                        <Page
                          key={`section-${idx}`}
                          number={1 + 5 + idx + 1}
                          handleSkipPage={handleSkipPage}
                        >
                          <div
                            className={` h-full p-2  ${isEdit ? "pb-10" : ""}`}
                          >
                            <SingleSection
                              heading={page.heading}
                              zone={page.zone}
                              images={page.images}
                              skus={page.skus}
                              renderImage={lastRenderImage}
                              brands={page.brands}
                              materials={page.materials}
                              metaDescriptions={
                                metaDescriptions?.[page.heading] || ""
                              }
                              key={page.heading}
                              isPublicView={true}
                              isEdit={isEdit}
                              isViewByZone={true}
                              showZoneLabel={viewBy === "brand"}
                              handleDeleteMaterial={(image) => {
                                if (!isEdit || !image) return;
                                let allMaterials = materialData?.[page.heading];
                                setSaveFinalMaterial((prev) => [
                                  ...prev,
                                  {
                                    zone: page.heading,
                                    from: allMaterials?.find((m) =>
                                      m?.images?.includes(image),
                                    )?._id,
                                    to: "",
                                  },
                                ]);
                                setMaterialData((prev) => {
                                  return {
                                    ...prev,
                                    [page.heading]: allMaterials?.filter(
                                      (m) => !m?.images?.includes(image),
                                    ),
                                  };
                                });
                              }}
                              selectedMaterialImg={{
                                image: selectedMaterial.image,
                                heading: selectedMaterial.heading,
                                material: selectedMaterial.material,
                              }}
                              selectedImage={(image) => {
                                if (!isEdit) return;
                                let allMaterials = materialData?.[page.heading];
                                let activeMaterial = allMaterials?.find((m) =>
                                  m?.images?.includes(image),
                                );
                                if (image == selectedMaterial?.image) {
                                  setSelectedMaterial({
                                    heading: "",
                                    material: "",
                                    image: "",
                                  });
                                } else {
                                  fetchRelatedMaterials(
                                    page.heading,
                                    activeMaterial?.materialType,
                                  );
                                  setSelectedMaterial((p) => {
                                    return {
                                      heading: page.heading,
                                      material: activeMaterial,
                                      image: image,
                                    };
                                  });
                                }
                              }}
                            />
                            {isEdit && (
                              <Button
                                colorScheme="teal"
                                position={"absolute"}
                                onClick={() => {
                                  setIsAddMaterialPopupOpen([
                                    true,
                                    page.heading,
                                  ]);
                                  fetchRelatedMaterials(page.heading);
                                }}
                                bottom={0}
                                size={"sm"}
                                left={"50%"}
                                className="-translate-x-1/2"
                              >
                                Add Material
                              </Button>
                            )}
                          </div>
                        </Page>,
                      );
                    }
                  });

                  const dividerPage =
                    tablePages.length > 0 ? (
                      <Page
                        key="tables-divider"
                        number={1 + 5 + sectionPages.length + 1}
                        handleSkipPage={handleSkipPage}
                      >
                        <TableHeadingPage isPdf={false} />
                      </Page>
                    ) : null;

                  return [...sectionPages, dividerPage, ...tablePages].filter(
                    Boolean,
                  );
                })()}
              {flipbookImages
                .filter((_, i) => i > 4)
                .map((image, idx) => (
                  <Page
                    key={`flipbook-end-${idx}`}
                    number={1 + 5 + data.length + idx + 1}
                    handleSkipPage={handleSkipPage}
                  >
                    <div className="p-2 rounded-xl overflow-hidden h-full">
                      <ImgOptimized
                        width="100%"
                        height="100%"
                        src={image}
                        alt={`Flipbook Image ${idx + 1}`}
                        className="w-full h-full "
                      />
                    </div>
                  </Page>
                ))}
              <Page
                key={"outro"}
                number={1 + 5 + data.length + (flipbookImages.length - 5) + 1}
                handleSkipPage={handleSkipPage}
              >
                <div className="h-full w-full p-2">
                  <OutroImage />
                </div>
              </Page>
            </HTMLFlipBook>
          </div>
        )}

        {/* <div
          className="fixed z-[100]"
          style={{
            top: skipButtonPosition.top,
            right: skipButtonPosition.right,
          }}
        >
          <div
            onClick={() => handleSkipPage()}
            size="md"
            className="cursor-pointer text-gray-300 underline"
          >
            Skip to content{" "}
          </div>
        </div> */}

        {isEdit && (
          <div className="flex gap-4 w-full overflow-x-auto  overflow-y-hidden">
            {relatedMaterials?.length > 0 &&
              selectedMaterial?.material &&
              relatedMaterials.map((v) => {
                const IS_SELECTED = v?._id == selectedMaterial?.material?._id;
                return (
                  <>
                    <div
                      onClick={() => !IS_SELECTED && handleSwapMAterial(v)}
                      className={`bg-white w-56 h-40 min-w-56 min-h-40  flex flex-col gap-2 rounded-xl overflow-hidden ${
                        IS_SELECTED ? "border-4 border-teal-600" : ""
                      }`}
                    >
                      <div
                        key={v.materialName}
                        className="grow bg-gray-100 h-full w-full overflow-hidden "
                      >
                        <CarasouelImages
                          autoPlaySpeed={Math.random() * 2000 + 3000}
                          images={v?.images?.map((i) => getMinioImage(i))}
                        />
                        {/* <Img
                          src={getMinioImage(v?.images?.[0])}
                          width="100%"
                          height="100%"
                          className={"W-full h-full object-cover"}
                        /> */}
                      </div>
                      <div className="px-2 relative">
                        {v.materialName}

                        {IS_SELECTED && (
                          <div className="absolute bottom-2 right-2">✅</div>
                        )}
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        )}
      </div>
      <div className="fixed">
        <PdfContent
          isMaterial={true}
          projectName={projectName}
          data={data}
          metaDescriptions={metaDescriptions}
          viewBy={viewBy}
        />
      </div>
      {isAddMaterialPopupOpen?.[0] && (
        <PopupWrapper
          heading={"Add Material"}
          isShowAction={true}
          width={"max-w-5xl"}
          onClose={() => {
            setIsAddMaterialPopupOpen([false, null]);
          }}
          handleSubmit={() => {
            if (!addSelectedMaterial) return;
            setMaterialData((prev) => {
              let update = prev?.[isAddMaterialPopupOpen?.[1]];
              if (!update) return prev;
              let updatedMaterials = [...update, addSelectedMaterial];
              return {
                ...prev,
                [isAddMaterialPopupOpen?.[1]]: updatedMaterials,
              };
            });
            setSaveFinalMaterial((p) => [
              ...p,
              {
                zone: isAddMaterialPopupOpen?.[1],
                from: "",
                to: addSelectedMaterial?._id,
              },
            ]);
            setAddSelectedMaterial(null);
            setIsAddMaterialPopupOpen([false, null]);
          }}
        >
          <div className="grid grid-cols-4 gap-4 max-h-[60vh] overflow-y-auto p-2">
            {relatedMaterials?.length > 0 &&
              relatedMaterials.map((v) => {
                return (
                  <div
                    onClick={() => {
                      setAddSelectedMaterial((p) => {
                        if (p && p._id == v._id) return null;
                        return v;
                      });
                    }}
                    className={`rounded-lg overflow-hidden relative border-2 ${addSelectedMaterial?._id == v._id ? "border-teal-600 " : "border-gray-300"} cursor-pointer`}
                  >
                    <div className="h-48 w-full overflow-hidden">
                      <CarasouelImages
                        images={v?.images?.map((i) => getMinioImage(i))}
                        autoPlaySpeed={Math.random() * 2000 + 3000}
                      />
                      {/* <Img
                    src={getMinioImage(v?.images?.[0])}
                    width="100%"
                    height="100%"
                    className={"W-full h-48 object-cover"}
                    /> */}
                    </div>
                    <div className="p-2">{v.materialName} </div>
                    {addSelectedMaterial?._id == v?._id && (
                      <div className="absolute bottom-2 right-2">✅</div>
                    )}
                  </div>
                );
              })}
          </div>
        </PopupWrapper>
      )}
    </div>
  );
};

const Page = React.forwardRef((props, ref) => {
  console.log("Page Props", props);
  return (
    <div className="demoPage h-full  w-full relative  " ref={ref}>
      {/* <h1>Page Header</h1> */}
      {props.children}
      {/* ASF */}
      {/* <p>Page number: {props.number}</p> */}
      <div className="absolute -bottom-6 text-sm right-0">
        <div
          onClick={() =>
            props?.handleSkipPage ? props.handleSkipPage() : () => {}
          }
          size="md"
          className="cursor-pointer text-gray-300 hover:underline  z-[1000] "
        >
          Skip to content{" "}
        </div>
      </div>
    </div>
  );
});

const PdfContent = ({
  isMaterial,
  projectName = "",
  data = [],
  metaDescriptions,
  viewBy,
}) => {
  return (
    <div id="landscapPdf" className="opacity-0 pointer-events-none">
      <div
        style={{
          backgroundImage: `url(${materialIntro})`,
          // backgroundSize: "contain",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",

          backgroundPosition: "left ",
          width: "100%",
          height: "100%",
        }}
        className="min-h-[100svh] pdfSection section1 w-full   relative"
      >
        {/*  <ImgOptimized src={intro} alt="Intro" className="w-full h-full " /> */}
        {/* <div className="absolute w-[12%] aspect-square top-0 right-0 flex items-center justify-center   ">
        <div className="text-lg sm:text-xl lg:text-xl xl:text-2xl  text-[#E8B995] font-semibold  text-center text-wrap ">
          {props?.projectName}
        </div>
      </div> */}
        <div className="absolute  w-[12%] aspect-square right-0 top-0 flex items-center  justify-center  ">
          <div className="text-lg sm:text-xl lg:text-2xl  text-[#E8B995] font-semibold  text-center text-wrap break-normal  ">
            {(projectName || " ")?.replaceAll("_", "/ ")}
          </div>
        </div>
      </div>

      {flipbookImages
        .filter((_, i) => i <= 4)
        .map((v, i) => (
          <div className="  overflow-hidden   h-[100svh] pdfSection">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
          </div>
        ))}
      {(() => {
        let lastRenderImage = null;
        const sectionPages = [];
        const tablePages = [];

        data.forEach((page, idx) => {
          if (page.type === "renderImage") {
            lastRenderImage = page.linkedImage;
            return;
          }

          if (page.type === "table") {
            tablePages.push(
              <div
                key={`table-pdf-${idx}`}
                className={`min-h-[100svh] h-full pdfSection w-full p-0 ${"section" + (idx + 2)}`}
              >
                <QuantityTable
                  values={page.tableData}
                  heading={page.heading}
                  isPdf={true}
                  isViewByZone={true}
                />
              </div>,
            );
            return;
          }

          if (page.type === "section") {
            sectionPages.push(
              <div
                key={`section-pdf-${idx}`}
                className={`min-h-[100svh] h-full pdfSection p-0 ${"section" + (idx + 2)}`}
              >
                <SingleSection
                  metaDescriptions={metaDescriptions?.[page.heading] || ""}
                  heading={page.heading}
                  zone={page.zone}
                  images={page.images}
                  brands={page.brands}
                  skus={page.skus}
                  renderImage={lastRenderImage}
                  key={page.heading}
                  isPublicView={false}
                  isPdfView={false}
                  isPdf={true}
                  materials={page.materials}
                  isViewByZone={true}
                  showZoneLabel={viewBy === "brand"}
                />
              </div>,
            );
          }
        });

        const dividerPage =
          tablePages.length > 0 ? <TableHeadingPage isPdf={true} /> : null;

        return [...sectionPages, dividerPage, ...tablePages].filter(Boolean);
      })()}
      {flipbookImages
        .filter((_, i) => i > 4)
        .map((v, i) => (
          <div className=" rounded-xl overflow-hidden min-h-[100svh] h-full pdfSection">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
          </div>
        ))}
      <div className="min-h-[100svh] h-full w-full pdfSection  ">
        <OutroImage isEdged={true} isPdf={true} />
      </div>
    </div>
  );
};

export default PublicView;
